export default "__VITE_ASSET__BlEFVJWT__"